
    var riot = require('riot')
    import { SaytRefinements } from './gb-sayt-refinements';
riot.tag2('gb-sayt-refinements', '<h4>{$navigation.displayName}</h4> <gb-list items="{$navigation.values}"> <gb-sayt-link send="{$sayt.searchRefinement}" data-value="{$navigation.displayName}: {$item}" data-refinement="{$item}" data-field="{$navigation.name}"> <yield> <gb-raw content="{$sayt.highlightCurrentQuery($item, \'<b>$&</b>\')}"></gb-raw> </yield> </gb-sayt-link> </gb-list>', 'gb-sayt-refinements.gb-stylish > h4,[data-is="gb-sayt-refinements"].gb-stylish > h4{ margin: 4px; }', '', function(opts) {
    this._mixin(SaytRefinements);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/sayt/gb-sayt-refinements.tag.html